import InfoAlert from './InfoAlert';

export default InfoAlert;
